// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
import { EDT } from '../../infrastructure/constants/common';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ party, code }) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const tz = party.tz ? party.tz : EDT;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const st = party.partyStatus !== 'deactivated' ? '' : ' (Deactivated)';
  return (
    <div className='party-main-info'>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <h1 className='header col-md-6 col-sm-6 party-name'>{`${party.partyName}${st}`}</h1>
      <div className='party-location'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {party.partyLocation ? party.partyLocation.address : ''}
      </div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {party.startDate && (
        <div className='party-event-dates'>
          <i className='fas fa-calendar' />
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {`${moment(party.startDate)
            // eslint-disable-next-line react/prop-types
            .tz(party.tz)
            // eslint-disable-next-line react/prop-types
            .format('MM/DD/YY')} - ${moment(party.endDate)
            // eslint-disable-next-line react/prop-types
            .tz(party.tz)
            .format('MM/DD/YY z')}`}
        </div>
      )}
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <div className='party-description'>{party.partyDescription}</div>
      <div className='clearfix' />
      <div className='party-additional'>
        <div className='party-additional-top'>
          <div className='party-info-item'>
            <span>Created at:</span>{' '}
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {moment(party.createdAt).tz(tz).format('MM/DD/YY')}
          </div>
          <div className='party-info-item'>
            <span>Party Type:</span>{' '}
            {/* eslint-disable-next-line react/prop-types */}
            {party.partyType}
          </div>
          <div className='party-info-item'>
            <span>Invite Code:</span>
            {code}
          </div>
        </div>
        <div className='party-info-item party-announcement'>
          <span>Party Announcement:</span>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {party.partyAnnouncement || 'none'}
        </div>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {party.partyCustomName && (
          <div className='party-info-item'>
            <span>Party Custom Name:</span>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {party.partyCustomName}
          </div>
        )}
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {party.partySize && (
          <div className='party-info-item'>
            <span>Party Size:</span>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {party.partySize}
          </div>
        )}
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {party.partyVibe && (
          <div className='party-info-item'>
            <span>Party Vibe:</span>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {party.partyVibe}
          </div>
        )}
      </div>
    </div>
  );
};
